import Icons from '@/shared/components/icon/Icons'
import { Text, Caption } from '@/shared/components/typography'

import { PARKINGLOT_TYPE, CATEGORY_SEQ, CATEGORY_LABEL } from '@/enums/detail'

interface SummaryTitleSectionViewProps {
  parkinglotName: string
  category: CATEGORY_SEQ
  parkinglotType: PARKINGLOT_TYPE
  qty: number
  isPartner: boolean
}

const SummaryTitleSectionView = ({
  parkinglotName,
  category,
  parkinglotType,
  qty,
  isPartner
}: SummaryTitleSectionViewProps) => {
  const getParkinglotCategoryLabel = (parkinglotType: PARKINGLOT_TYPE, category: CATEGORY_SEQ) => {
    if (parkinglotType === PARKINGLOT_TYPE.SHARE) {
      return category === CATEGORY_SEQ.PUBLIC ? '거주자우선' : '일반'
    }
    if (parkinglotType === PARKINGLOT_TYPE.PARKINGLOT && isPartner) return '제휴'
    if (category === CATEGORY_SEQ.PUBLIC) return CATEGORY_LABEL.PUBLIC
    else return CATEGORY_LABEL.PRIVATE
  }

  return (
    <div className="mb-[20px] px-[16px]">
      <Text level="text1" weight="bold" className="text-text-090">
        {parkinglotName}
      </Text>
      <div className="mt-[4px] flex items-center justify-start">
        <Caption level="caption2" weight="regular" color="text070">
          {getParkinglotCategoryLabel(parkinglotType, category)}
        </Caption>
        {qty ? (
          <>
            <div className="flex items-center justify-center pb-[2px]">
              <Icons.BulletIcon fill="currentColor" color="#6D7D90" />
            </div>
            <Caption level="caption2" weight="regular" color="text070">{`${qty.toLocaleString()}면`}</Caption>
          </>
        ) : null}
      </div>
    </div>
  )
}

export default SummaryTitleSectionView
